module.exports = __webpack_public_path__ + "img/loginform-user.e4d41023.svg";